import * as React from 'react'
import { styled } from '$utils/theme'
import { Icon } from '$views/components/Icon'

import errorIcon from '$icons/alert.svg'
import successIcon from '$icons/checkbox.svg'
import { rem } from 'polished'
import { css } from 'styled-components'

interface Props {
  className?: string
  error?: boolean
  success?: boolean
  icon?: string
}

const InputIconRaw: React.SFC<Props> = ({ className, error, success, icon }) => (
  <div className={className}>
    {icon && !(error || success) && <Icon content={icon} size="m" />}
    {success && <Icon content={successIcon} size="m" />}
    {error && <Icon content={errorIcon} size="m" />}
  </div>
)

export const InputIcon = styled(InputIconRaw)<Props>`
  position: absolute;
  right: ${p => rem(p.theme.sizes.mini)};
  top: ${p => rem(p.theme.sizes.mini)};

  ${p =>
    p.error &&
    css`
      path {
        fill: ${p.theme.colors.darkPink};
      }
    `};

  ${p =>
    p.success &&
    css`
      path {
        fill: ${p.theme.colors.semanticGreen};
      }
    `};
`



// WEBPACK FOOTER //
// ./src/views/components/Input/InputIcon.tsx